import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProfessionRegisterAffiliationService } from './profession-register-affiliation.service';

@Injectable()
export class ProfessionalRegisterAffiliationGuard implements CanActivate {

    constructor(
        private professionalRegisterAffiliationService: ProfessionRegisterAffiliationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.professionalRegisterAffiliationService.loadAll().pipe(map(() => true));
    }
}
